import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
//@ts-ignore
import logo from "../../assets/logo-white.png";
import { SportsBettingAPI } from "../../api/sportsBetting";
import SportsBettingCard from "../../components/SportsBettingCard";
import { getCommaSeparatedString } from "../../constants/Helper";
import { SportsBettingResponse } from "../../constants/responses";
import PreLoader from "../../components/PreLoader";
import { useTranslation } from "react-i18next";
import { useIpDetails } from "../../services/ip_provider";

const SportsBetting = () => {
  const { t } = useTranslation();
  const { ipData, loading: ipLoading, error } = useIpDetails();
  const [countryFlag, setCountryFlag] = useState<string | null>(null);
  const [countryName, setCountryName] = useState<string | null>(null);
  const [sports, setSports] = useState<SportsBettingResponse[]>();
  async function fetchSports() {
    try {
      const res = await SportsBettingAPI.getActive();
      if (res.data) {
        const sports = res.data;
        const sortedSports = Array.isArray(sports)
          ? sports.sort(
              (a, b) => parseInt(a.homeSequence) - parseInt(b.homeSequence)
            )
          : [];
        setSports(sortedSports);
      }
    } catch (error) {
      console.log("Something went wrong. Try Again!");
    }
  }
  useEffect(() => {
    if (ipData) {
      setCountryName(ipData.country_name);
      setCountryFlag(ipData.location.country_flag);
      fetchSports();
    }
  }, [ipData]);
  if (!countryName || !sports) return <PreLoader />;

  return (
    <Container
      fluid
      className="m-0 flex flex-col min-h-full w-full items-center text-white"
    >
      {/* Navbar */}
      <section className="w-full lg:w-[75%] lg:mt-[2rem] mb-2">
        <Link to="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[15rem] my-3 cursor-pointer"
          />
        </Link>
      </section>
      {sports && (
        <section className="w-full lg:w-[75%] flex flex-col justify-center items-center">
          <h2 className="my-[3rem] text-[1.6rem] lg:text-[2.5rem] font-defaultFont text-center">
            {t("best_sports")}
          </h2>
          <div className="w-[90%] lg:w-full">
            {sports.map((sport, index) => (
              <div className="w-full" key={index}>
                <SportsBettingCard
                  id={sport.id}
                  flag={countryFlag ?? ""}
                  country={countryName ?? ""}
                  allowedCountries={
                    sport.allowedCountries
                      ? getCommaSeparatedString(sport.allowedCountries)
                      : ""
                  }
                  index={index}
                  logo={sport.picture}
                  welcomeBonusText={sport.welcomeBonusText}
                  freeBonusText={sport.freeBonusText}
                  refURL={sport.refURL}
                />
              </div>
            ))}
          </div>
        </section>
      )}
    </Container>
  );
};

export default SportsBetting;
